/* eslint-disable import/no-cycle */
import React from 'react'
import StylesWithMaterialUi from '../../../VehicleDetails.styles'

const CustomOption = (handleLoadMore, count, CustomToolBar) => {
  const classes = StylesWithMaterialUi()
  return {
    responsive: 'vertical',
    selectableRows: 'none',
    selectToolbarPlacement: 'none',
    download: false,
    search: false,
    rowHover: true,
    fixedHeader: false,
    fixedSelectColumn: true,
    pagination: true,
    print: false,
    rowsPerPage: 4,
    count,
    rowsPerPageOptions: [],
    tableBodyMaxHeight: '400px',
    serverSide: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    filter: false,
    customToolbar: () => <CustomToolBar />,
    setRowProps: () => ({
      className: classes.border,
    }),
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          handleLoadMore(tableState.page)
          break
        default:
      }
    },
  }
}
export default CustomOption
